import React, { memo } from 'react';
import { Handle, Position } from 'react-flow-renderer';

const MessageNode = ({ data, isConnectable }) => {
  return (
    <div className="node node-message">
      <Handle type="target" position={Position.Top} isConnectable={isConnectable} />
      <div>
        <h4>{data.label}</h4>
        {data.text && <p>{data.text.length > 40 ? data.text.substring(0, 40) + '...' : data.text}</p>}
      </div>
      <Handle type="source" position={Position.Bottom} isConnectable={isConnectable} />
    </div>
  );
};

export default memo(MessageNode); 